/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TBuyPackageModel,
  IBuyPackageRequest,
  IMappers,
  IBuyPackageResponse,
  IBuyPackageResponseError,
  TBuyPackageResponse,
} from './types';

const defaultConfig: TBuyPackageModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'billing-service-packages-balancer',
  pathApi: '/v1/buy-package/',
  hostType: 'api',
} as TBuyPackageModel;

function createBuyPackageModel(parameters: IBuyPackageRequest): TBuyPackageModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IBuyPackageOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IBuyPackageRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchBuyPackage<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IBuyPackageOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TBuyPackageResponse> {
  const { response, statusCode } = await httpApi.fetch(createBuyPackageModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IBuyPackageResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IBuyPackageResponseError);
    }
  }

  return { response, statusCode } as TBuyPackageResponse;
}

export { defaultConfig, createBuyPackageModel, fetchBuyPackage };
